/**
 * Import required libraries
 */
import React, { useMemo, useState, useEffect } from "react";
import { connect } from "react-redux"
import { iconHex, getLabel } from "Utils";
import { licence as licenceApi } from "api";

/**
 * Import required elements
 */
// Material-ui icons
import DefaultIcon from "@material-ui/icons/Layers";
import { iconBase64 } from "../../../../utils/store/browserStorage";
import { Skeleton } from "@material-ui/lab";

/**
 * AppIcon Component
 */
function AppIconRender(props) {
  const { lang, name, icon, appUid, licenceUid, className, style } = props;

  const [iconURL, setIconURL] = useState(null)

  useEffect(() => {
    if (licenceUid && !icon && !appUid) { // cas du manager qui n'a pas accès aux apps et qui doit passer par les licences pour recupere les images
      const getInfo = async () => {
        let info = await licenceApi.getAppMeta(licenceUid);
        console.log("info :", info)
        iconHex(info.icon).then(setIconURL).catch(console.error)
      }
      getInfo()
    }
  }, [icon, appUid, licenceUid]);

  useEffect(() => {
    let mounted = true
    if (icon && !iconURL) {
      //console.log("urlA :", icon)
      const setUrl = url => {
        if (mounted) setIconURL(url)
      }
      iconHex(icon)
        .then(setUrl)
        .catch(() => iconBase64(icon)
          .then(setUrl)
          .catch(console.error)
        )
    }
    return () => mounted = false
  }, [iconURL, icon]);

  const appName = useMemo(() => {
    if (name) return getLabel(name, lang)
    else return ""
  }, [lang, name])

  const content = useMemo(() => {
    if (iconURL) return <img src={iconURL} alt={appName} className={className} style={style} />;
    else if (icon) return <Skeleton variant="circle" />
    else return <DefaultIcon />
  }, [icon, iconURL, appName, className, style])

  return content
}

/**
 * Export component
 */
// map redux state to props
const AppIcon = connect((state, ownProps) => {
  let licenceUid = ownProps.licenceUid || state.project.selectedLicenceUid
  let appUid = ownProps.appUid || null
  let mapState = {
    lang: state.locale.lang,
    licenceUid,
    appUid
  }
  if (appUid) {
    let { name, icon } = state.list.app[appUid] || {}
    if (icon) mapState.icon = icon
    if (name) mapState.name = name
  }
  return mapState
})(AppIconRender)

export default AppIcon

global.SimtopyAppIcon = AppIcon